/**
 * 年份数字转中文速查表
 * @Array Of Property
 * @trans ['零','一','二','三','四','五','六','七','八','九','十']
 * @return Cn string
 */
export default [
  '\u96f6',
  '\u4e00',
  '\u4e8c',
  '\u4e09',
  '\u56db',
  '\u4e94',
  '\u516d',
  '\u4e03',
  '\u516b',
  '\u4e5d',
  '\u5341'
];
